import type { Incident } from '../../services/incidentsApi';

export function resolveParentCaseIncidentId(
  selectedGroupContext: Record<string, unknown> | null | undefined,
  _selectedIncident: Incident | null | undefined,
): string {
  return String(
    (selectedGroupContext as any)?.review_anchor_incident_id
    || (selectedGroupContext as any)?.linked_detailed_record_id
    || (selectedGroupContext as any)?.incident_id
    || '',
  ).trim();
}

export function observationRemainingInPatternCount(
  patternObservationCount: number | null | undefined,
): number | null {
  const total = Math.max(0, Number(patternObservationCount) || 0);
  if (total <= 1) return null;
  return total - 1;
}

export function observationRemainingInPatternLabel(
  remainingCount: number | null | undefined,
): string | null {
  const count = Number(remainingCount);
  if (!Number.isFinite(count) || count <= 0) return null;
  return count === 1
    ? '1 related observation remaining'
    : `${count.toLocaleString()} related observations remaining`;
}

export function observationBackToCaseButtonLabel(
  patternObservationCount: number | null | undefined,
): string {
  const remaining = observationRemainingInPatternCount(patternObservationCount);
  const suffix = observationRemainingInPatternLabel(remaining);
  return suffix ? `Back to pattern · ${suffix}` : 'Back to pattern';
}

export function resolveNextObservationIncidentId(
  currentIncidentId: string | null | undefined,
  queue: Array<{ incident_id?: string | null }> | null | undefined,
): string | null {
  const current = String(currentIncidentId || '').trim();
  if (!current || !Array.isArray(queue) || queue.length < 2) return null;
  const ids = queue
    .map((row) => String(row?.incident_id || '').trim())
    .filter(Boolean);
  const currentIndex = ids.indexOf(current);
  if (currentIndex >= 0 && currentIndex < ids.length - 1) {
    return ids[currentIndex + 1];
  }
  const alternate = ids.find((id) => id !== current);
  return alternate || null;
}
